<template>
  <div>
    <v-autocomplete
      v-if="1"
      outlined
      :clearable="!readonly"
      :items="formattedOptions"
      v-model="v"
      item-text="text"
      item-value="value"
      menu-props="offset-y, auto, overflowY"
      :label="$t(titleValue)"
      :error-messages="error"
      :disabled="disabled"
      :hide-details="config.hideDetails || false"
      :readonly="readonly"
      :dense="config.dense || false"
      :small-chips="model.chips || false"
      :multiple="model.chips || false"
      :deletable-chips="model.chips || false"
      :hide-selected="model.chips || false"
      :tags="true"
      @blur="onEnter"
      @keydown.enter.prevent="onEnter"
    />
  </div>
</template>

<script>
import modelOptions from "./../../libs/modelOptions";

export default {
  mixins: [],
  props: {
    value: [String, Number, Array, Boolean],
    values: {
      type: Object,
      default: () => {
        return {};
      },
    },

    model: Object,
    label: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: "",
    },
    config: { type: Object, default: {}, disabled: false },
  },
  data() {
    return {
      listDisabled: [],
      cc: 0,
      showAllItem: false,
      title: null,
      preText: null,
      toggleSelect: false,
      customOptions: [],
    };
  },
  computed: {
    formattedOptions() {
      const res = this.options.map((opt) => {
        const minutes = this.parseToMinutes(opt);
        const res = {
          text: this.formatMinutes(minutes),
          value: minutes,
        };
        return res;
      });
      return [...res, ...this.customOptions];
    },
    v: {
      get() {
        let res = this.value;
        if (this.model.chips) {
          if (res === null || res === undefined) res = [];
          if (this.model.keyInObject) {
            res = (this.value || []).map((v) => v[this.model.keyInObject]);
          }
          if (!Array.isArray(res))
            try {
              res = res.split(",");
            } catch (error) {
              res = [res];
            }
        }
        return res;
      },
      set(v) {
        let res = v;
        if (this.model.keyInObject) {
          res = [
            ...v.map((e) => {
              return { [this.model.keyInObject]: e };
            }),
          ];
        }
        if (Array.isArray(v)) this.onInput(res.sort((a, b) => a - b));
        else this.onInput(res);
        //this.$emit("input", res);
      },
    },

    options() {
      let res = this.model?.durations || [];
      if (this.value) {
        if (Array.isArray(this.value)) res = [...res, ...this.value];
        else res = [...res, this.value];
      }
      return res;
    },

    readonly() {
      if (this.config?.readonly || this.model?.readonly) return true;
      return false;
    },
    titleValue() {
      return this.title || this.model.title;
    },
  },
  methods: {
    parseToMinutes(opt) {
      if (typeof opt === "number") return opt;
      const str = String(opt).trim().toUpperCase();
      if (str.endsWith("Н")) return 60 * 24 * 7 * parseInt(str) || 60 * 24 * 7;
      if (str.endsWith("Д")) return 60 * 24 * parseInt(str) || 60 * 24;
      if (str.endsWith("Ч")) return 60 * parseInt(str) || 60;
      if (str.endsWith("М")) return parseInt(str) || 5;
      return parseInt(str) || 0;
    },

    // Преобразуем минуты → человекочитаемый формат
    formatMinutes(mins) {
      if (mins == 0) return `${mins}м`;
      if (mins % (60 * 24 * 7) === 0) return `${mins / (60 * 24 * 7)}Н`;
      if (mins % (60 * 24) === 0) return `${mins / (60 * 24)}Д`;
      if (mins % 60 === 0) return `${mins / 60}Ч`;
      return `${mins}м`;
    },

    sendData(v) {
      let selected = this.options.find((d) => d?.[this.valueField] == v);
      if (selected) {
        this.$emit("fieldData", selected);
      }
      this.$emit("selected", selected);
    },
    onInput(e) {
      this.$emit("input", e);
      if (this.model?.cascade) {
        for (const key in this.model.cascade) {
          const el = this.model.cascade[key];
          if (el.type == "field") {
            let value = this.options.find((f) => f["value"] == e)?.[el.value];
            if (value !== undefined) {
              //this.$emit("cascade", { field: el.value, value });
              console.log("cascade ", { field: key, value });
              this.$emit("cascade", { field: key, value });
            }
          }
          if (el.type == "formula") {
            let func;
            let f = this.options.find((f) => f["value"] == e)?.[el.value];
            if (typeof f == "string") func = eval(f);
            let value = func(this.values);
            if (value !== undefined) {
              this.$emit("cascade", { field: key, value });
            }
          }
        }
      }
      this.sendData(e);
    },
    onUserInput() {
      // если v-model содержит строки, которых нет в options — пробуем распознать
      if (this.model.chips && Array.isArray(this.v)) {
        this.v = this.v.map((val) => this.ensureMinutes(val));
      } else {
        this.v = this.ensureMinutes(this.v);
      }
    },

    ensureMinutes(val) {
      console.log("ensureMinutes", val);
      if (typeof val === "number") return val;
      const mins = this.parseToMinutes(val);
      if (mins > 0) {
        // добавить в options, если нет
        if (!this.formattedOptions.find((o) => o.value === mins)) {
          this.formattedOptions.push({
            text: this.formatMinutes(mins),
            value: mins,
          });
        }
        return mins;
      }
      return val; // если не удалось распознать — оставляем строку
    },
    onEnter(e) {
      const input = e.target.value.trim();
      if (!input) return;
      console.log(input);
      const minutes = this.parseToMinutes(input);
      console.log(minutes);
      if (minutes > 0) {
        // добавить в options, если нет
        if (!this.formattedOptions.find((o) => o.value === minutes)) {
          this.customOptions.push({
            text: this.formatMinutes(minutes),
            value: minutes,
          });
        }

        // обновляем v-model
        if (this.model.chips) {
          this.v = Array.isArray(this.v) ? [...this.v, minutes] : [minutes];
        } else {
          this.v = minutes;
        }
      } else {
        console.warn("Невалидное значение:", input);
      }

      // очищаем инпут
      e.target.value = "";
    },
  },
};
</script>
<style lang="scss"></style>
